import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4184bffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "nav nav-pills nav-pills-custom py-5 overdue-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-icon mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar" })
], -1))
const _hoisted_5 = { class: "nav-text text-gray-800 fw-bold fs-6 lh-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary" }, null, -1))
const _hoisted_7 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-icon mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-plus text-light",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-bold fs-6 lh-1 text-light" }, " Add Reminder ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary" }, null, -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reminders, (reminder, key) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item mb-3 me-3 me-lg-6",
              key: key,
              onClick: ($event: any) => (_ctx.selectReminder(reminder))
            }, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link btn btn-outline btn-flex btn-color-muted flex-column overflow-hidden w-80px h-85px py-5 border", { active: _ctx.isActiveReminder(reminder) }])
              }, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(reminder.no_of_days) + " Days overdue", 1),
                _hoisted_6
              ], 2)
            ], 8, _hoisted_3))
          }), 128)),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", {
              class: "nav-link btn btn-flex btn-active-color-primary flex-column overflow-hidden w-80px h-85px py-5 border",
              href: "javascript:void(0)",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addReminder && _ctx.addReminder(...args)))
            }, _hoisted_11)
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_el_skeleton, {
        key: 1,
        rows: 2
      }))
}